import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useCrmProductFormSchema = () => {
  const { t } = useTranslation("product");

  const schema = useMemo(
    () =>
      z.object({
        crm_product_id: z
          .string()
          .min(
            1,
            t(
              "integrationProductListPage.crmModal.validations.crmProductIdRequired"
            )
          ),
        attributes: z
          .array(z.object({ key: z.string(), value: z.string() }))
          .optional(),
        media_url: z.string().optional(),
        hierarchy_name_level1: z.string().optional(),
        hierarchy_name_level2: z.string().optional(),
        hierarchy_name_level3: z.string().optional(),
        hierarchy_name_level4: z.string().optional(),
        media_file: z
          .instanceof(File)
          .refine(
            (file) => ["application/pdf"].includes(file.type),
            t(
              "integrationProductListPage.crmModal.validations.mediaFileInvalidType"
            )
          )
          .optional()
      }),
    [t]
  );

  return schema;
};

export type CrmProductFormSchema = z.infer<
  ReturnType<typeof useCrmProductFormSchema>
>;
